import { ForwardedRef, forwardRef } from "react";
import { SelectInstance } from "react-select";
import { AttributeType } from "__generated__/gql/graphql";
import AttributeSelect, {
  AttributeSelectOption,
  AttributeSelectWrapperProps,
} from "components/Shared/Select/AttributeSelect";

function ProductAttributeSelect(
  props: AttributeSelectWrapperProps,
  ref: ForwardedRef<SelectInstance<AttributeSelectOption, true>>,
) {
  return (
    <AttributeSelect
      {...props}
      ref={ref}
      attributeType={AttributeType.PRODUCT}
      placeholderLabel="Select product attributes…"
      noOptionsMessageLabel="No product attributes found"
    />
  );
}

export default forwardRef(ProductAttributeSelect);
